// extracted by mini-css-extract-plugin
export default {"countBuildings":"Establishments_countBuildings__9d0su","table":"Establishments_table__Zvs3f","close":"Establishments_close__rL1ch","search":"Establishments_search__gkfDH"};